import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { FronteggProvider } from '@frontegg/react';

/**
 * Environment selection
 * - Set REACT_APP_ENV to: test | staging | development | production
 * - Or rely on NODE_ENV when building
 * - Optionally override hosts/IDs via env vars:
 *     REACT_APP_FRONTEGG_BASE_URL
 *     REACT_APP_FRONTEGG_CLIENT_ID
 */
const ENV = process.env.REACT_APP_ENV || process.env.NODE_ENV;
const isTestLike = ['test', 'staging', 'development'].includes((ENV || '').toLowerCase());

// Defaults if you don’t provide REACT_APP_FRONTEGG_BASE_URL
const TEST_BASE_URL = 'https://app-bjh4d9jeoojw.us.frontegg.com';
const PROD_BASE_URL = 'https://oauth.wealthwriteup.com';

// Pick baseUrl (env override > sensible default)
const baseUrl =
    process.env.REACT_APP_FRONTEGG_BASE_URL ||
    (isTestLike ? TEST_BASE_URL : PROD_BASE_URL);

// Keep your current clientId, allow override via env if you have different ones per env
const clientId =
    process.env.REACT_APP_FRONTEGG_CLIENT_ID ||
    '7b45a1f3-3672-47ba-8763-99ad0cbefef3';

const contextOptions = { baseUrl, clientId };

// Full-screen Admin Portal look & feel (unchanged)
const themeOptions = {
    adminPortal: {
        layout: {
            fullScreenMode: true,
        },
    },
};

// (Optional) helpful log in non-prod
if (ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.log('[Frontegg] ENV:', ENV, 'baseUrl:', baseUrl);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <FronteggProvider
        contextOptions={contextOptions}
        themeOptions={themeOptions}
        hostedLoginBox
    >
        <App />
    </FronteggProvider>
);

reportWebVitals();
